export const CUSTOM_OPEN_RESTRICTED_ITEM_MODAL = 'open-restricted-item-modal';
export const CUSTOM_CLOSE_RESTRICTED_ITEM_MODAL = 'close-restricted-item-modal';
export enum RestrictedModalTypesEnum {
  UNAVAILABLE = 'unavailable_restricted_type',
  GEO = 'geo_restricted_type',
  PROJECT = 'project_restricted_type',
}
